export default __webpack_public_path__ + "static/media/Furore.7c2d2443.woff";